<!-- Modern Header/Navbar -->
<header class="modern-header">
  <div class="header-container">
    <!-- Logo Section -->
    <div class="logo-section">
      <div class="brand-info">
        <span class="brand-name">SME Timesheet</span>
        <span class="brand-tagline">Management Portal</span>
      </div>
    </div>

    <!-- Navigation Menu -->
    <nav class="nav-menu">
      <!-- Admin Navigation -->
      <div class="nav-group" *ngIf="router.url === '/admin/sendtimesheet' || router.url === '/admin/timesheet'">
        <a class="nav-link" routerLink="/admin/timesheet" routerLinkActive="active">
          <span class="nav-icon">📊</span>
          <span class="nav-text">Manage Timesheet</span>
        </a>
        <a class="nav-link" routerLink="/admin/sendtimesheet" routerLinkActive="active">
          <span class="nav-icon">📤</span>
          <span class="nav-text">Push Timesheet</span>
        </a>
      </div>

      <!-- Employee Navigation -->
      <div class="nav-group" *ngIf="router.url === '/timesheet/timesheet-n'">
        <a class="nav-link" routerLink="/timesheet/timesheet-n" routerLinkActive="active">
          <span class="nav-icon">⏰</span>
          <span class="nav-text">My Timesheet</span>
        </a>
      </div>
    </nav>

    <!-- User Section -->
    <div class="user-section">
      <!-- Employee User Info -->
      <div class="user-profile" *ngIf="router.url === '/timesheet/timesheet-n'">
        <div class="user-avatar">
          <span class="avatar-icon">👤</span>
        </div>
        <div class="user-details">
          <div class="user-name">{{ userName }}</div>
          <div class="user-role">{{ userRole }}</div>
        </div>
        <button class="logout-btn" (click)="logoutUser()" title="Logout">
          <span class="logout-icon">🚪</span>
          <span class="logout-text">Logout</span>
        </button>
      </div>

      <!-- Admin User Info -->
      <div class="user-profile" *ngIf="router.url.includes('/admin/') && !router.url.includes('/admin/login')">
        <div class="user-avatar">
          <span class="avatar-icon">👨‍💼</span>
        </div>
        <div class="user-details">
          <div class="user-name">Administrator</div>
          <div class="user-role">Admin Panel</div>
        </div>
        <button class="logout-btn" (click)="logoutAdmin()" title="Logout">
          <span class="logout-icon">🚪</span>
          <span class="logout-text">Logout</span>
        </button>
      </div>

      <!-- Company Logo -->
      <div class="company-logo">
        <img src="../../../assets/icons/i2e_Logo.png" alt="I2E Logo" class="company-logo-img">
      </div>
    </div>

    <!-- Mobile Menu Toggle -->
    <button class="mobile-menu-toggle" type="button" (click)="toggleMobileMenu()">
      <span class="hamburger-line"></span>
      <span class="hamburger-line"></span>
      <span class="hamburger-line"></span>
    </button>
  </div>

  <!-- Mobile Menu Overlay -->
  <div class="mobile-menu-overlay" [class.active]="mobileMenuOpen">
    <div class="mobile-menu-content">
      <!-- Admin Mobile Navigation -->
      <div class="mobile-nav-group" *ngIf="router.url === '/admin/sendtimesheet' || router.url === '/admin/timesheet'">
        <a class="mobile-nav-link" routerLink="/admin/timesheet" routerLinkActive="active" (click)="closeMobileMenu()">
          <span class="mobile-nav-icon">📊</span>
          <span class="mobile-nav-text">Manage Timesheet</span>
        </a>
        <a class="mobile-nav-link" routerLink="/admin/sendtimesheet" routerLinkActive="active" (click)="closeMobileMenu()">
          <span class="mobile-nav-icon">📤</span>
          <span class="mobile-nav-text">Push Timesheet</span>
        </a>
      </div>

      <!-- Employee Mobile Navigation -->
      <div class="mobile-nav-group" *ngIf="router.url === '/timesheet/timesheet-n'">
        <a class="mobile-nav-link" routerLink="/timesheet/timesheet-n" routerLinkActive="active" (click)="closeMobileMenu()">
          <span class="mobile-nav-icon">⏰</span>
          <span class="mobile-nav-text">My Timesheet</span>
        </a>
      </div>

      <!-- Mobile User Info -->
      <div class="mobile-user-info" *ngIf="router.url === '/timesheet/timesheet-n'">
        <div class="mobile-user-avatar">
          <span class="mobile-avatar-icon">👤</span>
        </div>
        <div class="mobile-user-details">
          <div class="mobile-user-name">{{ userName }}</div>
          <div class="mobile-user-role">{{ userRole }}</div>
        </div>
        <button class="mobile-logout-btn" (click)="logoutUser()">
          <span class="mobile-logout-icon">🚪</span>
          <span>Logout</span>
        </button>
      </div>
    </div>
  </div>
</header>